import UpdateDBAction from '../components/ClientList/Actions/UpdateDBAction';

export const layoutConfig = {
    lg: [
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c2',
        },
    ],
    md: [
        {
            h: 17,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c2',
        },
    ],
    xs: [
        {
            h: 17,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c2',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {},
    components: [
        {
            name: 'canopy-table',
            key: 'c2',
            apiDetails: {
                endpoint: `admin/users?`,
                endpointParams: {
                    page: '*,page',
                    per_page: '*,per_page',
                    keyword: 'keyword',
                    sort_column: 'sortColumn',
                    sort_direction: 'sortDirection',
                },
            },
            props: {
                dataKey: 'users',
                requiredQueryFields: ['parent_user_ids'],
                showDownloadOn: ['desktop'],
                CustomAction: <UpdateDBAction />,
                canSelectRows: true,
                showCheckboxesOnChildRows: false,
                showFilterOn: [],
                columns: [
                    {
                        key: 'displayName',
                        otherKeys: ['username'],
                        type: 'splitCell',
                        sticky: 'left',
                        colSpan: '3',
                        width: 200,
                        headerText: 'ui.mm.table-headers.parent-display-name',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        subTableColumns: {
                            type: 'text',
                        },
                        expandRow: true,
                        canSort: true,
                    },
                    {
                        key: 'id',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.client-id',
                    },
                    {
                        key: 'role',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.client-role',
                    },
                    {
                        key: 'userType',
                        type: 'text',
                        headerText: 'table-headers.client-type',
                    },
                    {
                        key: 'status',
                        type: 'text',
                        headerText: 'table-headers.status',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'createdAt',
                        type: 'date',
                        headerText: 'table-headers.created-on',
                        canSort: true,
                    },
                    {
                        key: 'lastLoginDate',
                        type: 'date',
                        headerText: 'table-headers.last-login',
                    },
                    {
                        key: 'lastDocumentUploaded',
                        type: 'date',
                        headerText: 'ui.mm.table-headers.last-doc-updated',
                    },
                    {
                        key: 'lastTransactionDate',
                        type: 'date',
                        headerText: 'ui.mm.table-headers.last-transaction',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'baseCurrency',
                        type: 'text',
                        headerText: 'table-headers.base-ccy',
                    },
                    {
                        key: 'networthBaseCcy',
                        type: 'amountDate',
                        headerText: 'ui.mm.table-headers.networth-base-value',
                        otherKeys: ['netWorthAsOfDate'],
                        canSort: true,
                    },
                    {
                        key: 'networthUsd',
                        type: 'amountDate',
                        headerText: 'ui.mm.table-headers.networth-usd',
                        otherKeys: ['netWorthAsOfDate'],
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'ytd',
                        type: 'amount',
                        headerText: 'table-headers.ytd-performance',
                        canSort: true,
                    },
                    {
                        key: 'ytdPercentage',
                        type: 'percent',
                        headerText: 'table-headers.ytd-performance-percent',
                        canSort: true,
                    },
                    {
                        key: 'actions',
                        type: 'actions',
                        showOnParentTable: true,
                        actions: [
                            {
                                name: 'view_portfolio',
                                path: '/portfolio/allocations',
                                selectedByDefaultOn: [
                                    'desktop',
                                    'mobile',
                                    'tablet',
                                ],
                            },
                        ],
                        headerText: 'table-headers.actions',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                    },
                ],
                per_page: 25,
                childRowsApi: 'admin/users/$id/children',
                ga_event_name: 'Client List',
            },
        },
    ],
};
